<template>
  <section class="section">
    <div class="container">
      <h2 class="section-title">联合熠知打造差异化竞争优势</h2>
      <p class="section-subtitle">掌握核心技术，从芯片到应用全链路深度优化</p>
      <div class="benefits-list benefits-list--quad">
        <div v-for="b in advantages" :key="b.title" class="benefit-item">
          <div class="benefit-content">
            <div class="benefit-tag"></div>
            <h3>{{ b.title }}</h3>
            <p>{{ b.desc }}</p>
          </div>
        </div>
      </div>
      <div class="highlights-grid">
        <template v-for="(c, i) in highlights" :key="c.title">
          <div class="highlights-card" >
            <h3>{{ c.title }}</h3>
            <p v-html="c.html" />
          </div>
          <svg v-if="i < highlights.length - 1" class="highlights-divider" xmlns="http://www.w3.org/2000/svg" width="1"
            height="98" viewBox="0 0 1 98" fill="none" aria-hidden="true">
            <path d="M0.5 0V98" :stroke="`url(#paint0_linear_highlight_${i})`" />
            <defs>
              <linearGradient :id="`paint0_linear_highlight_${i}`" x1="1" y1="98" x2="1" y2="0"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="white" stop-opacity="0" />
                <stop offset="0.5" stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0.01" />
              </linearGradient>
            </defs>
          </svg>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const advantages = [
  {
    title: 'x86 PC游戏仿真运行',
    desc: '掌握将x86架构PC游戏在ARM服务器环境下高效仿真运行的核心技术，降低性能损耗的同时保持对各类游戏的高兼容性，打破硬件架构限制。'
  },
  {
    title: '移动端游戏纹理移植',
    desc: '具备将移动端游戏纹理高效移植到消费级显卡的能力，通过智能算法优化渲染效果，在保证画面细节与色彩还原的同时，确保高帧率流畅运行。'
  },
  {
    title: '带外管理协议定制',
    desc: '支持服务器带外管理通信协议的定制化开发，深度契合客户现有的运维管理系统，实现设备状态实时监控与远程控制的无缝集成。'
  },
  {
    title: '集群功耗优化',
    desc: '利用先进的电源管理方案与动态任务调度算法，智能调节集群资源分配，在保障算力输出的前提下显著降低能耗，有效缩减运营成本。'
  }
];

const highlights = [
  // {
  //   title: '交付能力',
  //   html: '2026 H2 可交付：珠峰 1500台（6000卡）<br>熠知 4000~10000台'
  // },
  {
    title: '标杆案例',
    html: '云游戏智算集群<br>覆盖六大数据中心<br>全年可用性 98%'
  },
  {
    title: '资本保障',
    html: '依托上市企业禾盛新材（002290.SZ）<br>算力租赁专项定增资金<br>充足长期建设资金保障'
  }
];
</script>

<style scoped lang="scss">
.section {
  background: linear-gradient(0deg, #0E2661 0%, #2E2E2E 100%);
}

.highlights-grid {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  margin-top: 64px;
}

.highlights-divider {
  flex-shrink: 0;
  align-self: center;
}

.benefit-item {
  border-radius: 8px;
  border: 1px solid rgba(239, 239, 239, 0.20);
  padding: 24px 24px 48px 24px;

  .benefit-tag {
    width: 36px;
    height: 4px;
    background: #0095FF;
  }

  h3 {
    margin: 24px 0;
  }

  p {

    /* Noto Sans SC Regular 14 24 */

    font-size: 14px;
    line-height: 24px;
    opacity: 0.7;
    /* 171.429% */
  }
}

.highlights-card {
  flex: 1;
  min-width: 0;
&:not(:last-child) {
  text-align: right;
}
}

.highlights-card h3 {
  margin-bottom: 24px;
  /* Noto Sans SC Medium 18 32 */
  font-size: 18px;
  line-height: 32px;
  /* 177.778% */
}

.highlights-card p {

  /* Noto Sans SC Regular 14 24 */
  font-size: 14px;
  line-height: 24px;
  opacity: 0.7;
  /* 171.429% */
}

@media (max-width: 768px) {
  .highlights-grid {
    flex-direction: column;
    gap: 32px;
  }

  .highlights-divider {
    display: none;
  }
}
</style>
